import { useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import * as D from "assets/iconsSVG/rowTopDownIcon";
import * as MaterialUI from "@material-ui/core";
import SelectAutoComplete from "components/selectAutoCompleteG";
import { useGetLeads } from "services/api/AppWeb_Oportunidade/get-leads";
import { useVincularLead } from "services/api/AppWeb_Oportunidade/post-vincular-lead";
import * as S from "./styles";

interface Data {
  onClose: () => void;
  dataDetalheOportunidade: any;
  refetchDetalheOportunidade: () => void;
  refetchHistorico: () => void;
}

export const ModalVincular = (data: Data) => {
  const [value, setValue] = useState<any>({});
  const { mutate: mutateVincular, isLoading: isLoadingVincular } =
    useVincularLead();

  const { data: dataLeads, refetch: refetchLeads } = useGetLeads({
    enabled: true,
  });

  useEffect(() => {
    if (dataLeads?.data === undefined) {
      refetchLeads();
    }
  }, []);

  const handleSubmit = () => {
    mutateVincular(
      {
        idOportunidade: data.dataDetalheOportunidade.idOportunidade,
        IdLeadCorretor: value.value,
      },
      {
        onSuccess: () => {
          data.refetchDetalheOportunidade();
          data.refetchHistorico();
          data.onClose();
        },
      }
    );
  };

  return (
    <S.Content>
      <S.Header>
        <S.Row style={{ justifyContent: "space-between" }}>
          <D.RowTopDownIcon />
          <S.CloseButton onClick={data.onClose}>
            <IoCloseOutline size={32} />
          </S.CloseButton>
        </S.Row>
        <S.SpaceY space={16} />
        <S.TextTitle>Vincular Lead</S.TextTitle>
      </S.Header>
      <S.SpaceY space={16} />
      <S.Body>
        <S.InputContainer>
          <SelectAutoComplete
            label="Lead"
            value={value}
            onChange={(e: any) => {
              setValue(e);
            }}
            data={
              dataLeads?.map((item: any) => ({
                value: item?.idLeadCorretor,
                label: item?.nome,
              })) || []
            }
          />
        </S.InputContainer>
        <S.SpaceY space={32} />
        <S.Row style={{ gap: 16 }}>
          <S.Button
            onClick={() => {
              data.onClose();
            }}
            color="#ffffff"
            border="1px solid #A3A3A6"
          >
            <S.TextButton color="#424248">Cancelar</S.TextButton>
          </S.Button>
          <S.Button
            onClick={() => {
              handleSubmit();
            }}
            disabled={isLoadingVincular || !value}
          >
            {isLoadingVincular ? (
              <MaterialUI.CircularProgress
                size={22}
                style={{ color: "#ffffff" }}
              />
            ) : (
              <S.TextButton color="#FFFFFF">Vincular</S.TextButton>
            )}
          </S.Button>
        </S.Row>
      </S.Body>
    </S.Content>
  );
};
